<template>
  <el-card :key="modelValue.UserID">
    <template #header>
      <div>
        {{ title }}
        <!-- {{ modelValue._ ? (modelValue._.Paid ? '已支付' : modelValue._.Status == 'CFM' ? '审核通过' : '') : '' }} -->
      </div>
    </template>
    <el-form :model="modelValue" ref="formRefs" scroll-to-error :disabled="modelValue._ && (modelValue._.Paid || modelValue._.Status == 'CFM' || modelValue._.Disabled)">
      <el-row :gutter="20">
        <template v-for="it in fields" :key="it.id">
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item
              :label="it.title"
              :prop="it.id"
              :rules="[
                {
                  required: it.mandatory,
                  message: $t(`registration.form.required`, it),
                },
              ]"
            >
              <template v-if="it.id === 'Gender'">
                <el-select v-suggest-off v-model="modelValue[it.id]" style="width: 100%">
                  <template v-if="genderList && genderList.length">
                    <el-option v-for="it in genderList" :label="it" :value="it"></el-option>
                  </template>
                  <tempate v-else>
                    <template v-if="$event.Language === 1">
                      <el-option value="男" label="男"></el-option>
                      <el-option value="女" label="女"></el-option>
                    </template>
                    <template v-else>
                      <el-option value="Male" label="Male"></el-option>
                      <el-option value="Female" label="Female"></el-option>
                    </template>
                  </tempate>
                </el-select>
              </template>

              <template v-else-if="it.id === 'ExpDate' || it.id === 'Birthday'||it.id=='DateIssue'">
                <el-date-picker v-model="form[it.id]" type="date" placeholder="" value-format="YYYY-MM-DD" format="YYYY-MM-DD" />
              </template>

              <template v-else-if="it.id === 'Country'">
                <el-select v-suggest-off clearable v-model="modelValue[it.id]" style="width: 100%" filterable @change="handleAreaChange(modelValue)">
                  <el-option v-for="it in Area.countries" :key="it.ID" :label="it.Title[locale]" :value="it.Title[locale]"></el-option>
                </el-select>
              </template>
              <template v-else-if="it.id === 'State'">
                <el-select v-suggest-off clearable v-if="modelValue.Country && Area.states.length" v-model="modelValue.State" style="width: 100%" filterable @change="handleAreaChange(modelValue)">
                  <el-option v-for="it in Area.states" :key="it.ID" :label="it.Title[locale]" :value="it.Title[locale]"></el-option>
                </el-select>
                <el-input v-suggest-off v-else v-model="modelValue.State" placeholder=""></el-input>
              </template>
              <template v-else-if="it.id === 'City'">
                <el-select
                  v-suggest-off
                  clearable
                  v-if="modelValue.Country && modelValue.State && Area.cities.length"
                  v-model="modelValue.City"
                  style="width: 100%"
                  filterable
                  @change="handleAreaChange(modelValue)"
                >
                  <el-option v-for="it in Area.cities" :key="it.ID" :label="it.Title[locale]" :value="it.Title[locale]"></el-option>
                </el-select>
                <el-input v-suggest-off v-else v-model="modelValue.City" placeholder=""></el-input>
              </template>

              <template v-else-if="it.id === 'District'">
                <el-select
                  v-suggest-off
                  clearable
                  v-if="modelValue.Country && modelValue.State && modelValue.City && Area.districts.length"
                  v-model="modelValue.District"
                  style="width: 100%"
                  filterable
                >
                  <el-option v-for="it in Area.districts" :key="it.ID" :label="it.Title[locale]" :value="it.Title[locale]"></el-option>
                </el-select>

                <el-input v-suggest-off v-else v-model="modelValue.District" placeholder=""></el-input>
              </template>

              <template v-else>
                <el-input v-suggest-off v-model="modelValue[it.id]" />
              </template>
            </el-form-item>
          </el-col>
        </template>

        <template v-if="needQuestion">
          <template v-for="(it, idx) in questions" :key="it.id">
            <el-col :span="24">
              <el-form-item
                :prop="it.id"
                :rules="[
                  {
                    required: it.mandatory || (it.options.length == 1 && it.options[0].text && it.options[0].mandatory),
                    validator: (rule, value, callback) => validatorQuestion(it, rule, value, callback),
                    trigger: 'blur',
                  },
                ]"
                :question-id="it.id"
              >
                <template #label>
                  <span>{{ idx + 1 + '、' + it.title }}</span>

                  <div
                    @click="handleClear(it.id)"
                    class="clear"
                    v-if="
                    
                    !(modelValue._ && (modelValue._.Paid || modelValue._.Status == 'CFM' || modelValue._.Disabled))&&
                    it.clear && modelValue.Question && modelValue.Question.data && modelValue.Question.data[it.id] && Object.keys(modelValue.Question.data[it.id]).length > 0"
                  >
                    【{{ $t('registration.form.clear') }}】
                  </div>
                </template>
                <VControl v-model="modelValue.Question.data[it.id]" :data="it" style="width: 100%" />
              </el-form-item>
            </el-col>
          </template>
        </template>
      </el-row>
    </el-form>
  </el-card>
</template>
<script setup>
  import { onMounted, defineProps, ref, defineExpose, inject, reactive, computed } from 'vue'
  import { useAppStore } from '@/store/modules/app'
  import VControl from '../survey/control.vue'

  import UploadImage from '@/components/UploadImage'
  import UploadFile from '@/components/UploadFile'

  const props = defineProps({
    fields: {
      type: Array,
      default: () => {
        return []
      },
    },
    title: {
      type: String,
      default: '',
    },
    modelValue: {
      type: Object,
      default: () => {
        return {}
      },
    },
    questions: {
      type: Array,
      default: () => {
        return []
      },
    },
    needQuestion: {
      type: Boolean,
      default: false,
    },
  })
  const { area } = useAppStore()
  const $event = inject('$event')
  const Area = reactive({
    countries: [],
    states: [],
    cities: [],
    districts: [],
  })
  const locale = computed(() => {
    if ($event.Language == 2) return 1
    return 0
  })

  const formRefs = ref(null)

  const handleAreaChange = ({ Country, State, City }) => {
    if (Country) {
      Area.states = (area.find((x) => x.Title[0] === Country || x.Title[1] === Country || x.Title[2] === Country) || { children: [] }).children || []
      console.log('handleAreaChange', Area.states)
      Area.cities = []
      Area.districts = []
      if (State) {
        Area.cities = (Area.states.find((x) => x.Title[0] === State || x.Title[1] === State || x.Title[2] === State) || { children: [] }).children || []
        if (City) {
          Area.districts = (Area.cities.find((x) => x.Title[0] === City || x.Title[1] === City || x.Title[2] === City) || { children: [] }).children || []
        }
      }
    }
  }
  onMounted(() => {
    Area.countries = area.map((x) => {
      return {
        ID: x.ID,
        Title: x.Title,
      }
    })
    handleAreaChange(props.modelValue || {})
  })

  const validatorQuestion = (it, rule, value, callback) => {
    if (it.mandatory) {
      if (!props.modelValue.Question.data[it.id]) {
        callback(new Error(t(`registration.form.required`, it)))
        return
      }
      if (Object.keys(props.modelValue.Question.data[it.id]).length === 0) {
        callback(new Error(t(`registration.form.required`, it)))
        return
      }
      //如果当前只有一个值，且为
      if (it.options.length == 1 && it.options[0].text) {
        if (!(props.modelValue.Question.data[it.id] && props.modelValue.Question.data[it.id][it.options[0].code])) {
          callback(new Error(t(`registration.form.required`, it)))
          return
        }
      }
    }
    for (var g of it.options) {
      if (g.text && g.mandatory) {
        if (!(props.modelValue.Question.data[it.id] && props.modelValue.Question.data[it.id][g.code])) {
          callback(new Error(t(`registration.form.required`, it)))
          return
        }
      }
    }
    callback()
  }

  const genderList = computed(() => {
    for (var it of fields) {
      if (it.id === 'Gender' && it.remark) {
        return it.remark.split(';').filter((x) => x)
      }
    }
    return []
  })

  defineExpose({
    validate: async () => {
      return new Promise((resolve, reject) => {
        console.log('------------', formRefs.value)
        formRefs.value.validate((valid, fields) => {
          console.log('valid', valid)
          resolve({ valid, fields })
        })
      })
    },
  })


  const handleClear = (id) => {
    props.modelValue.Question.data[id] = {}
  }
  //
</script>

<style lang="scss" scoped>
  .el-card {
    background: #fff; // rgba(238, 242, 248, 0.6);
    border-radius: 12px;
    box-shadow: none;
    border-width: 1px !important;
    margin-bottom: 20px;
    border-color: var(--el-color-primary-light-8);
    :deep() {
      .el-card__header {
        background-color: var(--el-color-primary-light-8);
        border-bottom: solid 1px var(--el-color-primary-light-8);
        font-weight: bold;
        font-size: 12px;
      }
    }
  }

  .el-form-item {
    :deep() {
      .el-form-item__label {
        color: #363f5e;
        font-size: 14px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .clear {
          color: var(--el-color-primary);
          margin-left: 6px;
          cursor: pointer;
        }
      }
    }
  }
</style>
